import React, { useState } from 'react';

function msgClass(msg) {
  const t = msg.type || msg.direction;
  if (t === 'internal_note') return 'msg-internal-note';
  if (t === 'reply' || msg.direction === 'outbound') return 'msg-reply';
  return 'msg-inbound';
}

function msgTypeLabel(msg) {
  const t = msg.type || msg.direction;
  if (t === 'internal_note') return { label: 'Internal Note', cls: 'internal' };
  if (t === 'reply' || msg.direction === 'outbound') return { label: 'Public Reply', cls: 'reply' };
  return { label: 'Inbound', cls: 'inbound' };
}

export default function ConversationMessage({ msg }) {
  const [showQuoted, setShowQuoted] = useState(false);
  const hasQuoted = !!msg.body_html_quoted || !!msg.body_text_quoted;
  const typeInfo = msgTypeLabel(msg);

  return (
    <div className={`msg-card ${msgClass(msg)}`}>
      <div className="msg-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span className="msg-sender">{msg.from_name || msg.from_email}</span>
          {msg.from_name && (
            <span style={{ color: 'var(--topcx-text-muted)', fontSize: '0.75rem' }}>
              &lt;{msg.from_email}&gt;
            </span>
          )}
          <span className={`msg-type-badge ${typeInfo.cls}`}>{typeInfo.label}</span>
        </div>
        <span className="msg-time">
          {msg.created_at ? new Date(msg.created_at).toLocaleString() : ''}
        </span>
      </div>
      <div className="msg-body">
        {msg.body_html ? (
          <div dangerouslySetInnerHTML={{ __html: msg.body_html }} />
        ) : msg.body_text ? (
          <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', margin: 0 }}>
            {msg.body_text}
          </pre>
        ) : (
          <span style={{ color: 'var(--topcx-text-muted)', fontSize: '0.8rem' }}>(no content)</span>
        )}

        {hasQuoted && (
          <>
            <button
              onClick={() => setShowQuoted(!showQuoted)}
              style={{
                display: 'inline-flex',
                background: '#e9ecef',
                border: '1px solid #dee2e6',
                borderRadius: 4,
                padding: '2px 10px',
                cursor: 'pointer',
                marginTop: 8,
                fontSize: '0.8rem',
                color: '#6c757d',
                letterSpacing: '0.15em',
              }}
              title={showQuoted ? 'Hide quoted text' : 'Show quoted text'}
            >
              &#x2026;
            </button>
            {showQuoted && (
              <div style={{ marginTop: 8, paddingLeft: 12, borderLeft: '2px solid #dee2e6', color: '#6c757d' }}>
                {msg.body_html_quoted ? (
                  <div style={{ fontSize: '0.85rem' }} dangerouslySetInnerHTML={{ __html: msg.body_html_quoted }} />
                ) : (
                  <pre style={{ fontSize: '0.85rem', whiteSpace: 'pre-wrap', fontFamily: 'inherit', margin: 0 }}>
                    {msg.body_text_quoted}
                  </pre>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
